export const booleanToText = (value) => {
  return value ? "oui" : "non";
}
